// extracted by css-extract-rspack-plugin
export default {"button":"rkP8QWB9M5g8rJ2p"};